/* import __COLOCATED_TEMPLATE__ from './topic.hbs'; */
import Component from "@glimmer/component";
import { service } from "@ember/service";

export default class Results extends Component {
  @service siteSettings;
}
